// R1b-γ — Financial Contracts tab.
// Read-only rehome of the tenant's contracts list. Phase 2 CRM→Contract→Deposit
// preserved: this view links back to the deep editor at /crm/contracts/{id}.
import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { Link } from "react-router-dom";
import EmptyState from "../../../components/EmptyState";
import { FileText, ExternalLink } from "lucide-react";

export default function FinancialContractsTab() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/contracts").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);

  return (
    <div data-testid="financial-contracts-body">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <div className="font-display font-semibold text-erf-dark text-lg">Contracts</div>
          <div className="text-xs font-nav text-erf-dark/60 mt-0.5" data-testid="contracts-count">
            {rows === null ? "Loading…" : `${rows.length} contract(s) · deposit workflow lives under /crm/contracts`}
          </div>
        </div>
      </div>

      {rows !== null && rows.length === 0 && (
        <EmptyState icon={FileText} title="No contracts yet" subtitle="Convert an opportunity in /crm/opportunities to create your first contract." />
      )}

      {rows !== null && rows.length > 0 && (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Title</th>
                <th className="text-left px-3 py-2">Client</th>
                <th className="text-left px-3 py-2">Amount</th>
                <th className="text-left px-3 py-2">Status</th>
                <th className="text-right px-3 py-2">Open</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} className="border-t border-erf-borderCream/60" data-testid={`contract-row-${c.id}`}>
                  <td className="px-3 py-2 font-nav font-semibold">{c.title || c.name || "—"}</td>
                  <td className="px-3 py-2 mono text-[11px]">{c.client_name || c.client_id || "—"}</td>
                  <td className="px-3 py-2 mono">{c.amount != null ? `$${Number(c.amount).toLocaleString()}` : "—"}</td>
                  <td className="px-3 py-2 mono text-[11px] uppercase">{c.status || "draft"}</td>
                  <td className="px-3 py-2 text-right">
                    <Link
                      to={`/crm/contracts/${c.id}`}
                      className="inline-flex items-center gap-1 text-erf-dark hover:text-erf-goldHover underline underline-offset-2 decoration-erf-gold/60 hover:decoration-erf-goldHover text-xs font-nav font-semibold"
                      data-testid={`contract-open-${c.id}`}
                      aria-label={`Open contract ${c.title || c.name || c.id}`}
                    >
                      Open <ExternalLink className="w-3 h-3" aria-hidden="true" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
